export default __webpack_public_path__ + "static/media/LebenswerkAlliedServices.7b4a3905.svg";